var React = require('react');

function DownloadInverse (props) {
    return React.createElement("svg",props,[React.createElement("style",{"id":"style837","key":0}),React.createElement("path",{"id":"circle2","d":"m8.9902 0a9 9 0 00-8.9902 9 9 9 0 009 9 9 9 0 009-9 9 9 0 00-9-9 9 9 0 00-.0097656 0zm-1.3242 5h2.668v5h2.666l-4 4-4-4h2.666v-5z","style":{"fill":"#ffffff"},"key":1})]);
}

DownloadInverse.defaultProps = {"id":"svg6","fill":"none","version":"1.1","viewBox":"0 0 18 18","width":"18","height":"18"};

module.exports = DownloadInverse;

DownloadInverse.default = DownloadInverse;
